import React from 'react';
import PropTypes from 'prop-types';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import { FormattedNumber } from 'react-intl';
import ChargeRow from 'chargeComponents/ChargeRow';
import ChargeCommentTextBox from 'chargeComponents/ChargeCommentTextBox';

class ChargeRadioGroup extends React.Component {

    constructor(props) {
        super(props);
        this.onRadioGroupChange = this
            .onRadioGroupChange
            .bind(this);
    }

    onRadioGroupChange(e, selectedValue) {

        const { groupedItems, chargeActions, orderId } = this.props;

        const prevselectedItem = groupedItems.find((groupedItem) => {
            return groupedItem.get('quantity') === 1;
        })

        chargeActions.chargeQuantitySet(prevselectedItem.get('chargeID'), 0, orderId);

        const selectedItem = groupedItems.find((groupedItem) => {
            return groupedItem.get('chargeID') === selectedValue;
        });

        chargeActions.chargeQuantitySet(selectedItem.get('chargeID'), 1, orderId);

    }

    render() {

        const { groupedItems, orderId, chargeActions, disabled } = this.props;
        if (!groupedItems || groupedItems.count() === 0) {
            return null;
        }

        const radioOptions = [];
        let valueSelected = null;
        let message = '';
        let error = '';
        let loading = false;
        let hasUnsavedChanges = false;

        let commentInput = null;

        groupedItems.forEach((charge) => {

            if (charge.get('quantity') === 1) {
                valueSelected = charge.get('chargeID');
            }
            if (charge.get('message')) {
                message = message += charge.get('message');
            }
            if (charge.get('error')) {
                error = error += charge.get('error');
            }

            if (charge.get('loading')) {
                loading = true;
            }

            if (charge.get('hasUnsavedChanges') && charge.get('requiresComment')) {
                hasUnsavedChanges = true;
            }

            if (charge.get('requiresComment') && charge.get('quantity') > 0) {
                commentInput = (<ChargeCommentTextBox
                    hasUnsavedChanges={hasUnsavedChanges}
                    charge={charge}
                    orderId={orderId}
                    disabled={disabled}
                    chargeActions={chargeActions} />);
            }

            radioOptions.push((
                <RadioButton
                    disabled={disabled}
                    labelStyle={{
                        textAlign: 'right',
                        paddingRight: '15px'
                    }}
                    key={'radio_option_' + charge.get('chargeID')}
                    value={charge.get('chargeID')}
                    label={< FormattedNumber value={
                        charge.get('cost')
                    }
                        style="currency" currency="USD" />} />
            ));

        });

        const option = (
            <div>
                <RadioButtonGroup
                    labelPosition="left"
                    valueSelected={valueSelected}
                    onChange={this.onRadioGroupChange}
                    name={groupedItems
                        .first()
                        .get('description')}>
                    {radioOptions}
                </RadioButtonGroup>
                {commentInput}
            </div>
        );

        return (<ChargeRow
            hasUnsavedChanges={hasUnsavedChanges}
            title={groupedItems
                .first()
                .get('description')}
            option={option}
            loading={loading}
            message={message}
            error={error} />);
    }
}

ChargeRadioGroup.propTypes = {
    groupedItems: PropTypes.object,
    chargeActions: PropTypes.object,
    orderId: PropTypes.string,
    disabled: PropTypes.bool

};
export default ChargeRadioGroup;


// WEBPACK FOOTER //
// ./src/components/charges/ChargeRadioGroup.js